import axios from 'axios';

import * as config from '../../config';

export default {
  state: {
    sort: 'AdoptionDate',
    sortDirection: 'DESC',
    adoptions: [],
    totalAdoptions: 0,
    maxPages: 0,
    search: '',
    gender: 'All',
    species: 'All',
    animalSpecies: [],
  },
  actions: {
    async getAdoptions({ rootState, state, commit }, page) {
      try {
        let params = [
          `page=${encodeURIComponent(rootState.route.params.page || 1)}`,
          `limit=${encodeURIComponent(config.PAGE_SIZE)}`,
          `sort=${encodeURIComponent(state.sort)}`,
          `dir=${encodeURIComponent(state.sortDirection)}`,
          `search=${encodeURIComponent(state.search)}`,
          `species=${encodeURIComponent(state.species)}`,
          `gender=${encodeURIComponent(state.gender)}`,
        ];

        let response = await axios.get(`${config.API_URL}/adoptions?${params.join('&')}`);

        commit('setAdoptions', response);

        return response;
      } catch (e) {}
    },
    async getAdoptionAnimalSpecies({ state, commit }) {
      try {
        let response = await axios.get(`${config.API_URL}/adoptions/species`);

        commit('update', { state, property: 'animalSpecies', value: response.data });

        return response;
      } catch (e) {}
    },
  },
  mutations: {
    setAdoptions(state, { data }) {
      state.adoptions = data.items;

      state.totalAdoptions = data.total_results;

      state.maxPages = Math.ceil(data.total_results / config.PAGE_SIZE)
    },
  },
  getters: {
    adoptionPages(state, getters, rootState) {
      let page = parseInt(rootState.route.params.page) || 1,
        numPages = state.maxPages < 5 ? state.maxPages : 5,
        pages = [];

      if (page <= Math.ceil(numPages / 2)) {
        for (let i = 1; i <= numPages; i++) {
          pages.push(i);
        }
      } else if (page > state.maxPages - Math.floor(numPages / 2)) {
        for (let i = state.maxPages; i > state.maxPages - numPages; i--) {
          pages.push(i);
        }
        pages.reverse();
      } else {
        return [page - 2, page - 1, page, page + 1, page + 2];
      }

      return pages;
    }
  },
};